<ng-container *transloco="let t;">
    <div *ngIf="fieldData?.selected_field === SelectedFieldEnum.TextField">
        <div class="form-group d-flex justify-content-between align-items-center px-1 mb-2">
            <label class="col-form-label pt-0 pb-0" for="name">{{t("Field settings Field calculation (Template/Document - section) - Calculation")}}</label>
            <div class="custom-control custom-control-primary custom-switch ">
                <input type="checkbox" class="custom-control-input" id="Calculation" (change)="addCalculation($event)" [checked]="enable_calculation" />
                <label class="custom-control-label" for="Calculation"></label>
            </div>
        </div>

        <div class="form-group px-1 position-relative calculation-arithmetic-operators">
            <ng-template styleClass="asad" #popContent>
                <button *ngFor="let operator of ['+', '-', '*', '/', '%', '=IF()']" type="button" class="btn btn-icon btn-warning" rippleEffect (click)="addArithmeticOperators(operator)">
                    <span>{{operator}}</span>
                </button>
            </ng-template>
            <div class="input-group input-group-merge isCalculationField" *ngIf="enable_calculation">
                <input
                [ngbPopover]="popContent" 
                #calculation_text
                type="text"
                class="form-control"
                placeholder='{{t("Field settings Field calculation Example (Template/Document - section) - Example")}}: [f1] + [f2]'
                (keyup)="searchTextField($event)"
                />
                <div class="input-group-append">
                    <span class="input-group-text text-success" id="basic-addon6" (click)="saveCalculation()">{{t("Field settings Add calculation formla (Template/Document - section) - Add")}}</span>
                </div>
            </div>
            <div role="listbox" aria-label="Options list" class="ng-dropdown-panel ng-select-bottom droplist-dropdown-calculation" *ngIf="calculationFields.length > 0">
                <div class="ng-dropdown-panel-items scroll-host">
                    <div class="ng-option"
                        *ngFor="let field of calculationFields; let i = index"
                        (click)="selectCalculation(field)"
                        [ngClass]="{'active': i === highlightedIndex}">
                    <span class="ng-option-label">{{ field.select_type_text }}</span>
                    </div>
                </div>
            </div>

        </div>

        <div class="calculation-tags px-1 mb-2" *ngIf="calculation && enable_calculation">
            <div class="badge badge-primary">
                <span>{{calculation}}</span>
                <span (click)="editCalculation()"><i data-feather="edit-2"></i></span>
                <span (click)="removeCalculation()"><i data-feather="x"></i></span>
            </div>
        </div>

        <div class="form-group px-1" *ngIf="enable_calculation">
            <input type="number" class="form-control" [placeholder]='t("Field settings Add decimals for calculation (Template/Document - section) - Add decimals")' [value]="calculation_decimal" (change)="addDecimal($event)"/>
        </div>  
    </div>
</ng-container>